import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["menus", "footer", "width", "className", "fixed", "onMenuClick", "children"];
import { ConfigContext, Layout, Menu } from "@pionex-web-kit/components";
import cns from "classnames";
import React, { useContext, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import matchPath from "../utils/matchPath";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
// TODO: 把react route相关的库全删掉
export function BasicSider(_ref) {
  var menus = _ref.menus,
    footer = _ref.footer,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 240 : _ref$width,
    className = _ref.className,
    _ref$fixed = _ref.fixed,
    fixed = _ref$fixed === void 0 ? true : _ref$fixed,
    onMenuClick = _ref.onMenuClick,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var prefixCls = getPrefixCls("basic-layout-sider");
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var selectedKey = useMemo(function () {
    return findMenuNode(menus || [], pathname).map(function (item) {
      return item.key || item.path;
    });
  }, [pathname, menus]);
  var menuNode = useMemo(function () {
    if (!menus) {
      return null;
    }
    var defaultOpenKeys = getDefaultOpenKeys(toMenu(menus));
    return /*#__PURE__*/_jsx(Menu
    // FIXME: 当openKeys变更后，重渲染menu
    , {
      className: "".concat(prefixCls, "-menu"),
      inlineIndent: 0,
      items: toMenu(menus),
      mode: "inline",
      selectedKeys: selectedKey,
      defaultOpenKeys: defaultOpenKeys,
      onClick: function onClick(info) {
        onMenuClick === null || onMenuClick === void 0 ? void 0 : onMenuClick(info);
      }
    }, defaultOpenKeys.join(","));
  }, [menus, pathname, selectedKey, onMenuClick]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [fixed && /*#__PURE__*/_jsx("div", {
      style: {
        width: width,
        flex: "0 0 ".concat(width, "px"),
        overflow: "hidden",
        minWidth: width,
        maxWidth: width,
        transition: "background-color 0.3s ease 0s, min-width 0.3s ease 0s, max-width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) 0s"
      }
    }), /*#__PURE__*/_jsxs(Layout.Sider, _objectSpread(_objectSpread({
      className: cns("".concat(prefixCls), _defineProperty({}, "".concat(prefixCls, "-fixed"), fixed), className),
      width: width
    }, props), {}, {
      children: [menuNode, children, footer && /*#__PURE__*/_jsx("div", {
        className: cns("".concat(prefixCls, "-footer")),
        children: footer
      })]
    }))]
  });
}
function toMenuItem(item) {
  var _item$path, _item$children;
  for (var _len = arguments.length, indexList = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    indexList[_key - 1] = arguments[_key];
  }
  return {
    key: item.key || ((_item$path = item.path) === null || _item$path === void 0 ? void 0 : _item$path.split("?")[0]) || "key-".concat(indexList.join("-")),
    label: item.type || ((_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.length) > 0 ? item.name || item.title : /*#__PURE__*/_jsx(Link, {
      to: item.path,
      children: item.name || item.title
    }),
    type: item.type,
    icon: item.icon || /*#__PURE__*/_jsx("div", {
      style: {
        width: 20
      }
    })
  };
}
function toMenu(list) {
  for (var _len2 = arguments.length, indexList = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    indexList[_key2 - 1] = arguments[_key2];
  }
  return list.map(function (item, index) {
    var _item$children2;
    if (((_item$children2 = item.children) === null || _item$children2 === void 0 ? void 0 : _item$children2.length) > 0) {
      return _objectSpread(_objectSpread({}, toMenuItem.apply(void 0, [item].concat(indexList, [index]))), {}, {
        children: toMenu.apply(void 0, [item.children].concat(indexList, [index]))
      });
    }
    return toMenuItem.apply(void 0, [item].concat(indexList, [index]));
  });
}
function getDefaultOpenKeys(menus) {
  var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  menus.map(function (item) {
    var _item$children3;
    if (((_item$children3 = item.children) === null || _item$children3 === void 0 ? void 0 : _item$children3.length) > 0) {
      list.push(item.key);
      getDefaultOpenKeys(item.children, list);
    }
  });
  return list;
}
export function findMenuNode(menus, path) {
  var paths = [];
  var loop = function loop(list, arr) {
    var _iterator = _createForOfIteratorHelper(list),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _m$children;
        var m = _step.value;
        if (matchPath(path, {
          path: m.key || m.path,
          exact: false
        })) {
          arr.push(m);
        }
        if (((_m$children = m.children) === null || _m$children === void 0 ? void 0 : _m$children.length) > 0) {
          loop(m.children, arr);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  loop(menus, paths);
  return paths;
}